import { WidgetHeader } from 'legacy/lut/components/widgets/public/partner360/widgetHeader/WidgetHeader'

import { Translation } from 'cng-common/features/translations/components/translation'
import { Button } from 'core-components/library/button'

import styles from './ConfirmMpsTargetsSplitDialogContent.module.scss'

interface IProps {
  mpsSplitMessage: string
  onConfirm: () => void
  onClose: () => void
}

export const ConfirmMpsTargetsSplitDialogContent = ({
  mpsSplitMessage,
  onConfirm,
  onClose,
}: IProps) => {
  return (
    <div className={styles.root}>
      <WidgetHeader>jbp-mps-targets-split-confirm-title</WidgetHeader>
      <p>{mpsSplitMessage}</p>
      <div className={styles.btns}>
        <Button className={styles.btns__btn} onClick={onConfirm}>
          <Translation text="jbp-mps-targets-split-confirm-apply" />
        </Button>
        <Button color="grey" onClick={onClose}>
          <Translation text="jbp-mps-targets-split-confirm-cancel" />
        </Button>
      </div>
    </div>
  )
}
